'use client'

import { useHydrateAtoms } from 'jotai/utils'

import { qrUriAtom } from '../../generatorState'
import { imagesContentAtom, TImagesContent } from './imagesContentState'
import { ImagesScreen } from './ImagesScreen/ImagesScreen'

export const ImagesLandingScreen = ({
	uri,
	content,
}: {
	uri: string
	content: TImagesContent
}) => {
	useHydrateAtoms([
		[qrUriAtom, uri],
		[imagesContentAtom, content],
	])

	return <ImagesScreen previewMode={false} demoMode={false} />
}
